import * as S from "./styles.ts";
import ArchStandaloneSectionComponent from "@template/blocks/ArchStandaloneSection/component";
import Image, { ImageProps } from "@template/components/Image";

interface IHeroFooterImageProps {
  image: ImageProps;
  altStyling?: boolean;
}

export const HeroFooterImage = ({
  image,
  altStyling,
}: IHeroFooterImageProps) => {
  return (
    <S.HeroFooterImageContainer $altStyling={altStyling}>
      {altStyling && (
        <ArchStandaloneSectionComponent
          color="white"
          background="dark"
          withPadding={true}
          style={{
            position: "absolute",
            top: "29%",
            left: 0,
            right: 0,
            zIndex: 1,
          }}
        />
      )}
      <S.FooterImageContainer>
        <Image
          src={image.src}
          alt={image.alt}
          height={image.height || 700}
          width={image.width || 1200}
          priority={true}
        />
      </S.FooterImageContainer>
    </S.HeroFooterImageContainer>
  );
};
